import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { GeneralService } from "src/app/services/general.service";
import { TicketBulkService } from "src/app/services/settings-services/ticket-bulk.service";
import { FacebookService } from "src/app/services/social/facebook.service";

@Component({
  selector: "app-facebook-pages",
  templateUrl: "./facebook-pages.component.html",
  styleUrls: ["./facebook-pages.component.css"],
})
export class FacebookPagesComponent implements OnInit {
  loading: boolean = false;
  activePage: any = {};
  pages: Array<any> = [];
  selectedPage: any = {};
  orgEmail: any;
  inboundComms: any;

  constructor(
    private facebookService: FacebookService,
    private toaster: ToastrService,
    private ticketBulk: TicketBulkService,
    public gs: GeneralService,
  ) {
    this.orgEmail = this.gs.orgEmailTicket;
  }

  ngOnInit() {
    this.getOrganizationPages();
    this.getInboundComms();
  }

  getOrganizationPages() {
    this.facebookService.fetchOrganizationPages().subscribe(
      (response) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
          this.pages = payload.pages;
          this.activePage = payload.active_page || {};
        } else {
          this.toaster.error("Failed to load pages data.");
        }
      },
      (e) => e
    );
  }

  getInboundComms() {
    this.ticketBulk.getInboundComms().subscribe((res: any) => {
      this.inboundComms = res
    })
  }

  saveInboundComms(fbPage, igPage) {
    const payload = { ...this.inboundComms, facebookPage: fbPage, instagramPage: igPage, email: this.orgEmail };
    this.ticketBulk.saveInboundComms(payload).subscribe((res: any) => {})
    this.getInboundComms();
  }

  saveActivePage() {
    if (
      this.activePage.id == this.selectedPage.id ||
      !Object.keys(this.selectedPage).length
    ) {
      this.toaster.error(`No change to save.`);
      return;
    }

    this.loading = true;
    this.facebookService
      .updateOrganizationPages({ ...this.selectedPage })
      .subscribe(
        (response) => {
          this.loading = false;
          const { status_code } = response;
          if (status_code == 200) {
            this.toaster.success("Changes saved successfully.");
            this.activePage = this.selectedPage;
            const fbUsername = this.activePage.name? this.activePage.name: "";
            const igUsername = this.activePage.instagram_business_account? this.activePage.instagram_business_account.name : "";
            this.saveInboundComms(fbUsername, igUsername)
          } else {
            this.toaster.error(`Could not save changes.`);
          }
        },
        (e) => {
          this.loading = false;
        }
      );
  }

  selectPage(page: any) {
    this.selectedPage = page;
  }
}
